import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "tech-we-have-used"
    }}>{`Tech We Have Used`}</h2>
    <p>{`We have used monorepo folder structure with Yarn Workspace. In our app we have three different services:`}</p>
    <ul>
      <li parentName="ul">{`api`}</li>
      <li parentName="ul">{`shop`}</li>
      <li parentName="ul">{`admin`}</li>
    </ul>
    <p>{`Tech specification for specific part is given below:`}</p>
    <h2 {...{
      "id": "admin-dashboard"
    }}>{`Admin Dashboard`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nextjs.org/"
        }}>{`NextJs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.typescriptlang.org/"
        }}>{`Typescript`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://tailwindcss.com/"
        }}>{`Tailwindcss`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://react-hook-form.com/"
        }}>{`React Hook Form`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://react-query.tanstack.com/"
        }}>{`React-Query`}</a></li>
    </ul>
    <h2 {...{
      "id": "shop-frontend"
    }}>{`Shop Frontend`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nextjs.org/"
        }}>{`NextJs`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.typescriptlang.org/"
        }}>{`Typescript`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://tailwindcss.com/"
        }}>{`Tailwindcss`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://react-hook-form.com/"
        }}>{`React Hook Form`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://react-query.tanstack.com/"
        }}>{`React-Query`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/garmeeh/next-seo"
        }}>{`Next SEO`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/shadowwalker/next-pwa"
        }}>{`Next PWA`}</a></li>
    </ul>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ul>
      <li parentName="ul">{`Laravel`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      